import { ReactComponent as LocationTelehealth } from "assets/svg/session-badge-indicator-icons/location-telehealth.svg";
import { ReactComponent as NoteStatusAttachedOrInProgress } from "assets/svg/session-badge-indicator-icons/note-status-attached-or-in-progress.svg";
import { ReactComponent as NoteStatusSignedAndSubmitted } from "assets/svg/session-badge-indicator-icons/note-status-signed-and-submitted.svg";
import { ReactComponent as PaymentMethodCCHold } from "assets/svg/session-badge-indicator-icons/payment-method-cc-hold.svg";
import { ReactComponent as PaymentMethodInvoice } from "assets/svg/session-badge-indicator-icons/payment-method-invoice.svg";
import { ReactComponent as RepeatModifiedSeries } from "assets/svg/session-badge-indicator-icons/repeat-modified-series.svg";
import { ReactComponent as RepeatSeries } from "assets/svg/session-badge-indicator-icons/repeat-series.svg";
import { ReactElement, useMemo } from "react";
import getClasses from "utils/getClasses";
import styles from "./SessionIndicatorIcons.module.scss";

export interface SessionIndicatorIconsData {
  paymentMethod: "cc-hold" | "invoice";
  repeat: "series" | "modified-series" | "none";
  noteStatus: "attached-or-in-progress" | "signed-and-submitted" | "none";
  location: "telehealth" | "in-person";
}

interface SessionIndicatorIconsProps {
  className?: string;
  data: SessionIndicatorIconsData;
  maxDisplayedIcons: number;
}

const SessionIndicatorIcons = ({
  data,
  className,
  maxDisplayedIcons,
}: SessionIndicatorIconsProps) => {
  const iconsToShow = useMemo(() => {
    const icons: ReactElement[] = [];

    if (maxDisplayedIcons < 1) {
      return icons;
    }

    if (data.location === "telehealth") {
      icons.push(<LocationTelehealth key="location-telehealth" />);
    }

    if (maxDisplayedIcons < 2) {
      return icons;
    }

    if (data.paymentMethod === "cc-hold") {
      icons.push(<PaymentMethodCCHold key="payment-method-cc-hold" />);
    } else if (data.paymentMethod === "invoice") {
      icons.push(<PaymentMethodInvoice key="payment-method-invoice" />);
    }

    if (maxDisplayedIcons < 3) {
      return icons;
    }

    if (data.repeat === "series") {
      icons.push(<RepeatSeries key="repeat-series" />);
    } else if (data.repeat === "modified-series") {
      icons.push(<RepeatModifiedSeries key="repeat-modified-series" />);
    }

    if (maxDisplayedIcons < 4) {
      return icons;
    }

    if (data.noteStatus === "attached-or-in-progress") {
      icons.push(
        <NoteStatusAttachedOrInProgress key="note-status-attached-or-in-progress" />,
      );
    } else if (data.noteStatus === "signed-and-submitted") {
      icons.push(
        <NoteStatusSignedAndSubmitted key="note-status-signed-and-submitter" />,
      );
    }

    return icons;
  }, [data, maxDisplayedIcons]);

  return (
    <div className={getClasses(styles["container"], className)}>
      {iconsToShow}
    </div>
  );
};

export default SessionIndicatorIcons;
